import React from 'react';
import { PropTypes } from 'prop-types';

import {
  Form,
  Input,
  Select,
} from 'antd';
import { TrafficTypes } from '../../constants/System';

const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};

const { Option } = Select;

const APIKeyForm = ({
  form,
  handleChangeTrafficType,
  selectedTrafficTypes,
}) => (
  <Form
    name="basic"
    className="gx-form-row0"
    ref={form}
    {...formItemLayout}
  >
    <Form.Item
      label="Webhook URL"
      name="webhook_url"
    >
      <Input />
    </Form.Item>
    <Form.Item
      label="Webhook Hash"
      name="webhook_hash"
    >
      <Input />
    </Form.Item>
    <Form.Item
      label="Traffic types"
      name="traffic_types"
    >
      <Select
        mode="multiple"
        allowClear
        style={{ width: '100%' }}
        placeholder="Select allowed traffic type"
        value={selectedTrafficTypes}
        onChange={handleChangeTrafficType}
        showSearch
        optionFilterProp="children"
        filterOption={(input, option) => option.children.toLowerCase()
          .indexOf(input.toLowerCase()) >= 0}
      >
        {
            TrafficTypes && TrafficTypes.map((trafficType) => (
              <Option className="gx-text-capitalize" key={trafficType}>{trafficType}</Option>))
          }
      </Select>
    </Form.Item>
    <Form.Item
      label="IP Whitelist"
      name="ip_whitelist"
    >
      <Select
        mode="tags"
        style={{ width: '100%' }}
        placeholder="Add ip addresses to whitelist"
      />
    </Form.Item>
  </Form>
);

APIKeyForm.propTypes = {
  form: PropTypes.shape({
    current: PropTypes.shape({}),
  }),
  merchant_types: PropTypes.shape([]),
  handleChangeTrafficType: PropTypes.func.isRequired,
  selectedTrafficTypes: PropTypes.string.isRequired,
};

APIKeyForm.defaultProps = {
  form: {},
  merchant_types: [],
};

export default APIKeyForm;
